module.exports = __webpack_public_path__ + "static/media/logoIconeGray.503a520b.svg";